// =============================================================================
// GRAY SHARK BARBERSHOP — MAIN JS (ES Modules)
// =============================================================================

import '../scss/main.scss';

import { initHeader } from './modules/header.js';
import { initScrollReveal } from './modules/scrollReveal.js';
import { initSmoothScroll } from './modules/smoothScroll.js';
import { initFormValidation } from './modules/formValidation.js';
import { initImageFallback } from './modules/imageFallback.js';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initScrollReveal();
  initSmoothScroll();
  initFormValidation();
  initImageFallback();
});
